﻿export function startLoadingAnimation(button) {
    button.setAttribute('aria-disabled', true);

    const template = document.querySelector('#loading-icon');
    const clone = template.content.cloneNode(true);

    // We want the button to stay the same width/height, but remove the label text.
    // Instead of calculating a width, we can just invisibly render the text.
    const visuallyHiddenSpan = document.createElement('span');
    visuallyHiddenSpan.classList.add('invisible');

    // Although this might seem like a copy at first, this is a move of the nodes.
    visuallyHiddenSpan.append(...button.childNodes);

    button.appendChild(visuallyHiddenSpan);
    button.appendChild(clone);
}

export function stopLoadingAnimation(button) {
    button.setAttribute('aria-disabled', false);

    const visuallyHiddenSpan = button.querySelector('.invisible');

    // Although this might seem like a copy at first, this is a move of the nodes.
    button.append(...visuallyHiddenSpan.childNodes);

    visuallyHiddenSpan.remove();

    const spinner = button.querySelector(".button-spinner-wrapper");
    spinner.remove();
}
